// @ts-ignore
import CataloguePageLayout from '@sprinx/cvo-eshop-ui-common/pages/CataloguePage/CataloguePageLayout';
import React from 'react';
import { AfterPage, AfterPageProps } from '../../@sprinx/after-razzle';
import catalogueData from '../../api/catalogueData';
import AppLayout from '../../layouts/AppLayout';
import { CataloguePageData } from '../../types/CataloguePageData';
import { LayoutData } from '../../types/LayoutData';
import ErrorPage from '../ErrorPage';
import NotFoundPage from '../NotFoundPage';

export interface CataloguePageProps extends AfterPageProps<CataloguePageRouteParams> {
  data?: CataloguePageData;
}

interface CataloguePageRouteParams {
  pathParts: string;
}

declare global {
  // eslint-disable-next-line no-var
  var commonThings: LayoutData;
}

const CataloguePage: AfterPage<CataloguePageRouteParams, CataloguePageProps> = ({ data, error }) => {
  if (error) return <ErrorPage error={error} />;
  if (!data) return <NotFoundPage />;

  const { catalogueTaxonomy } = data;

  const { commonThings } = (typeof window !== 'undefined' && window) || global;

  const { header, footer } = commonThings;

  return (
    <AppLayout headerProps={header} footerProps={footer}>
      <CataloguePageLayout catalogueTaxonomy={catalogueTaxonomy} />
    </AppLayout>
  );
};

CataloguePage.getInitialProps = async ({ match }) => {
  // const layout = await commonData.get();
  const { pathParts } = match.params;
  const catalogueTaxonomy = await catalogueData.get({ href: `/${pathParts}` });
  const data: CataloguePageData = {
    catalogueTaxonomy,
    title: catalogueTaxonomy.title,
    // layout,
  };

  return {
    data,
  };
};

export default CataloguePage;
